export default __webpack_public_path__ + "static/media/bike.7d92f9f4.png";